export default __webpack_public_path__ + "static/media/logo_24.4a18216b.svg";